import Image from 'global/Image';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import { useEffect, useState } from 'react';
import ModalShare from 'global/ModalShare';
import { useDispatch } from 'react-redux';
import { effects as liveStreamEffects } from 'lib/entities/livestream';
import { effects as chatEffects } from 'lib/entities/chat/slice';
import { EVENT_STATUS } from 'global/LiveStreamWidget/constants';
import { PROJECT_FOLDER } from 'constants/app';
import { format, parseISO } from 'date-fns';
import { copyTextToClipboard } from 'utils/general';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import { downloadReminder } from './utils';
import {
  IconContainer,
  WidgetInfoActionContainer,
} from './styled';
import ModalQuestion from './Modal/ModalQuestion';
import ItemInfoAction from './ItemInfoAction';
import LivestreamAnalytics from './analytics/Livestream';
import LivestreamQuestionAnalytics from './analytics/Question';

interface WidgetInfoActionProps {
  event: any;
}

function WidgetInfoAction({ event }: WidgetInfoActionProps) {
  const {
    schedule,
    id: eventId,
    code: eventCode,
    title: eventTitle,
    reminder_enabled: showReminder,
    question_enabled: questionEnabled,
    status,
  } = event;

  const dispatch = useDispatch();
  const [startTime, endTime] = [
    format(parseISO(schedule.start), 'HH:mm'),
    format(parseISO(schedule.end), 'HH:mm'),
  ];
  const [showShareModal, setShowShareModal] = useState(false);
  const [showQnaModal, setShowQnaModal] = useState(false);
  const [sharedUrl, setSharedUrl] = useState('');

  const defaultClevertapParams = {
    event_date: format(parseISO(schedule.start), 'dd MMMM yyyy'),
    event_status: status === EVENT_STATUS.LIVE ? 'Live' : 'Upcoming',
    live_stream_name: eventTitle,
  };

  const onSubmitQuestion = async (question) => {
    const submitQuestion = await dispatch(liveStreamEffects.writeQuestion({
      id: eventId,
      question,
    }));

    // @ts-ignore
    const { data } = submitQuestion.payload;

    if (data) {
      LivestreamQuestionAnalytics.Action.questionSubmited(defaultClevertapParams);
      return data;
    }
    return false;
  };

  const onSetReminder = () => {
    downloadReminder(schedule.start, schedule.end, eventTitle);

    const cleverTapParams = {
      status: 'on',
      ...defaultClevertapParams,
    };
    LivestreamAnalytics.Action.setReminder(cleverTapParams);
  };

  const handleClickShowShareModal = () => {
    setShowShareModal(true);

    LivestreamAnalytics.Action.shareButtonSelected(defaultClevertapParams);
  };

  const handleClickQnaButton = () => {
    LivestreamQuestionAnalytics.Action.openModal(defaultClevertapParams);
    setShowQnaModal(true);
    LivestreamQuestionAnalytics.Navigate.View();
  };

  const handleCopyLink = () => {
    copyTextToClipboard(
      sharedUrl,
      () => handleErrorMessageAPI(
        'Link Copied! Go ahead and share it!', 'plain-green',
      ),
    );
  };

  const shareToChat = async (chatData) => {
    const send = await dispatch(chatEffects.shareEventToChat({
      ...chatData,
      attachment_url: '',
    }));
      // @ts-ignore
    const { error } = send.payload;

    if (!error) {
      setShowShareModal(false);
    }
  };

  useEffect(() => {
    const path = !PROJECT_FOLDER || PROJECT_FOLDER === '/' ? '/' : `/${PROJECT_FOLDER}/`;
    setSharedUrl(`${window.location.origin}${path}stream/event/${eventCode}/${eventId}`);
  }, []);

  const sharedMessage = `Tonton live stream ${eventTitle} di Stockbit.\n${sharedUrl}`;
  const showQna = status !== EVENT_STATUS.ENDED && questionEnabled;

  return (
    <WidgetInfoActionContainer id="livestream-widget-info">
      <Flex align="center">
        <IconContainer>
          <Image src="/icon/calendar-green.svg" />
        </IconContainer>
        <Flex direction="column">
          <Text
            family="bold"
            size="13px"
            height="18px"
            weight="700"
            color={color.highempahis}
            id="livestream-widget-info-date"
          >
            {format(parseISO(schedule.start), 'dd MMMM yyyy')}
          </Text>
          <Text
            size="11px"
            height="15px"
            weight="400"
            color={color.highgray}
            id="livestream-widget-info-time"
          >
            {startTime} - {endTime} WIB
          </Text>
        </Flex>
      </Flex>
      {showReminder && (
        <>
          <ItemInfoAction
            onClick={onSetReminder}
            title="Set Reminder"
            description="Get notification when the event is live"
            iconName="notification-green"
            id="livestream-widget-info-reminder"
          />
        </>
      )}
      {showQna && (
        <ItemInfoAction
          onClick={handleClickQnaButton}
          title="Submit Questions"
          description="You can ask up to 3 questions"
          iconName="chat-green"
          id="livestream-widget-info-qna"
        />
      )}
      <ItemInfoAction
        onClick={handleClickShowShareModal}
        title="Share This Event"
        description={null}
        iconName="share-green"
        id="livestream-widget-info-share"
      />
      <ModalShare
        visible={showShareModal}
        onCancel={() => setShowShareModal(false)}
        title="Share"
        sendChat={(chatData) => shareToChat(chatData)}
        hasSocialMedia
        hasShareInput
        hasRepostButton
        hasCopyButton
        urlToShare={sharedUrl}
        defaultSharedMessage={sharedMessage}
        onCopy={handleCopyLink}
      />
      <ModalQuestion
        visible={showQnaModal}
        onCancel={() => setShowQnaModal(false)}
        onSubmit={onSubmitQuestion}
      />
    </WidgetInfoActionContainer>
  );
}

export default WidgetInfoAction;
